import { render, staticRenderFns } from "./MenheraEmoji.vue?vue&type=template&id=3fdcf991&"
import script from "./MenheraEmoji.vue?vue&type=script&lang=js&"
export * from "./MenheraEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports